import { DialogModifyModList } from './DialogModifyModList';

export default {
    ModifyModList: DialogModifyModList,
};
